import { apiClient } from './api';
import type { ApiResponse, SupportRequest } from '@/types';

class SupportService {
  async create(data: { agent_id?: string; description: string }): Promise<SupportRequest> {
    const response = await apiClient.post<ApiResponse<SupportRequest>>('/support', data);
    if (response.data.data) return response.data.data;
    throw new Error('Failed to create support request');
  }

  async list(): Promise<SupportRequest[]> {
    const response = await apiClient.get<ApiResponse<SupportRequest[]>>('/support');
    return response.data.data || [];
  }
}

export const supportService = new SupportService();
